import { render, staticRenderFns } from "./EventOverviewIcon.vue?vue&type=template&id=6a53c0da"
import script from "./EventOverviewIcon.vue?vue&type=script&lang=js"
export * from "./EventOverviewIcon.vue?vue&type=script&lang=js"
import style0 from "./EventOverviewIcon.vue?vue&type=style&index=0&id=6a53c0da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports